import { useNavigate } from "react-router-dom";
import { HeaderSidebar } from "../../../components/Header/HeaderSidebar"
import { useState, useEffect } from "react";
import { getProductForm } from "../../../services/autofillService";
import { Formik, Form, Field, FieldArray } from "formik";
import { Step } from "../../../components/Step/Step";
import { getClassName } from "../../../utils";
import { questions, videos } from "../../../content/purpose/product"
import { TextareaAutosize } from "@mui/material";
import { AddMore } from "../../../components/Buttons/AddMoreButton";
import { UpButton } from "../../../components/Buttons/UpButton";
import { DownButton } from "../../../components/Buttons/DownButton";
import { useDispatch } from "react-redux";
import { setProgress } from "../../../store/progressSlice";
import { ProgressLine } from "../../../components/Progress/Line";
import { Buttons } from "../../../components/Stepper/StepperButtons";
import { Oval } from "react-loader-spinner";
import { submitProduct } from "../../../services/answersService";
import { getPurposeStatement } from "../../../services/statementsService";

export const PurposeProduct = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({
        productService1: [
            {
                productService: ''
            },
        ],
        combine: ''
    });

    const handleSubmit = values => {
        setIsLoading(true);
        submitProduct(values).then(response => {
            setIsLoading(false);
            navigate("/flow/vision");
            // navigate("/flow/purpose/statement")
        }).catch(err => {
            setIsLoading(false);
            console.error(err);
        });

        // getPurposeStatement().then(response => {
        //     const data = response.data;
        //     navigate("/flow/vision");
        // }).catch(err => {
        //     console.error(err);
        // })
    };

    const handleUpClick = () => {
        setActiveStep(activeStep - 1);
        if (activeStep === 1) {
            dispatch(setProgress(40))
        }
    }

    const handleDownClick = () => {
        setActiveStep(activeStep + 1);
        if (activeStep === 0) {
            dispatch(setProgress(43));
        }
    }

    const combineInformation = (values) => (
        <div className="flex flex-col gap-2 flex-1">
            <p className="text-light-grey text-sm">Products/Services:</p>
            <ul className="flex-1">
                {values.productService1.map((el, index) => (
                    <li className="text-light-grey text-sm" key={index}>
                        {el.productService}
                    </li>
                ))}
            </ul>
        </div>
    )

    useEffect(() => {
        dispatch(setProgress(40));
        getProductForm().then(response => {
            const data = response.data;
            if (data) {
                setInitialValues(data);
            }
        }).catch(err => {
            console.error(err);
        })
    }, []);
    return (
        <>
            <ProgressLine />
            <section className="h-dvh overflow-hidden flex flex-col items-center justify-center">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched }) => (
                        <>
                            <Form className="w-full max-w-[35%] h-full relative flex flex-col items-start justify-center">
                                <section className="flex flex-col items-center justify-center w-full h-full">
                                    <Step className={getClassName(0, activeStep)} question={questions.productService1} url={videos.impactService1Video.url}>
                                        <FieldArray name="productService1">
                                            {({ insert, remove, push }) => (
                                                <>
                                                    {values.productService1.length > 0 &&
                                                        values.productService1.map((productService, index) => (
                                                            <Field
                                                                name={`productService1.${index}.productService`}
                                                                placeholder="Write the product or service that you are providing"
                                                                className="has-border-bottom mt-3"
                                                                key={index}
                                                                as={TextareaAutosize}
                                                            />
                                                        ))
                                                    }
                                                    <AddMore onClick={() => push({ productService: '' })} />
                                                </>
                                            )}
                                        </FieldArray>
                                    </Step>
                                    <Step
                                        className={getClassName(1, activeStep)}
                                        question={questions.combine}
                                        url={videos.combineVideo.url}
                                        information={combineInformation(values)}
                                    >
                                        <Field
                                            name='combine'
                                            placeholder="Your offering in one sentence"
                                            className="has-border-bottom mt-3"
                                            as={TextareaAutosize}
                                        />
                                    </Step>
                                </section>
                                <Buttons link="/flow/purpose/impact">
                                    <UpButton onClick={handleUpClick} disabled={activeStep === 0} />
                                    {(activeStep === 1) ? (
                                        <button type="submit" className="btn yellow-cta">
                                            {isLoading ? <Oval
                                                height={30}
                                                width={50}
                                                color="black"
                                                secondaryColor="black"
                                            /> : (
                                                <span>
                                                    Next
                                                </span>
                                            )}
                                        </button>
                                    ) : (
                                        <DownButton onClick={handleDownClick} disabled={activeStep === 1} />
                                    )}
                                </Buttons>
                            </Form>
                        </>
                    )}
                </Formik>
            </section>
            <HeaderSidebar activeEl="Purpose" />
        </>
    )
}